






































































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalManualFactor from './ModalManualFactor.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { set } from 'tiny-cookie';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalManualFactor,
        DeleteConfirmation
    }
})
export default class ManualFactors extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    itemsManualFactorsTable: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    items: Array<object>;
    @Prop() vehicleID: number | null;
    @Prop({ default: false }) seeAll: boolean;
    @Prop({ default: false }) disabledRow: boolean;
    @Prop({ default: false }) saveOnMemory: boolean;
    itemsManualFactors: Array<object> = [];
    patchData: object | null = null;
    manualFactorToDelete: object | null = null;
    loadingTable: boolean = false;
    visibleModalManualFactor: boolean = false;
    headers: Array<object> = [
        {
            text: 'Fecha Inicio',
            value: 'start_date',
            formatter: this.dateFormatter,
            sortable: true,
            width: '180px'
        },
        {
            text: 'Fecha Fin',
            value: 'end_date',
            formatter: this.dateFormatter,
            sortable: true,
            width: '180px'
        },
        {
            text: 'Factor de calibración (%)',
            value: 'calibration_factor',
            align: 'center',
            sortable: true
        },
        {
            text: 'Factor de calibración Humedad (%)',
            value: 'humidity_calibration_factor',
            align: 'center',
            sortable: true
        },
        {
            text: 'Generado por descalibración',
            value: 'automatically_generated',
            align: 'center',
            sortable: true,
            formatter: this.formatBoolean
        },
        {
            text: 'Acciones',
            value: 'actions',
            sortable: true,
            width: '80px'
        }
    ];

    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    @Watch('items', { immediate: true, deep: true })
    observableItems() {
        this.itemsManualFactors = this.items;
    }

    pendingTable(value) {
        this.loadingTable = value;
    }

    addNewManualFactorToList(newItem) {
        this.itemsManualFactors.push(newItem);
    }

    getCurrentManualFactors() {
        return this.itemsManualFactors;
    }

    @Emit()
    viewAllManualFactors() {}

    @Emit()
    disabledManualFactor(item) {
        return item;
    }

    updateManualFactorInList(updatedFactor) {
        let indexToUpdate = matchedIndexIdInArray(this.itemsManualFactors, updatedFactor['id']);
        if (indexToUpdate !== -1) {
            this.$set(this.itemsManualFactors[indexToUpdate], 'end_date', updatedFactor['end_date']);
            this.$set(this.itemsManualFactors[indexToUpdate], 'start_date', updatedFactor['start_date']);
            this.$set(
                this.itemsManualFactors[indexToUpdate],
                'calibration_factor',
                updatedFactor['calibration_factor']
            );
            this.$set(
                this.itemsManualFactors[indexToUpdate],
                'humidity_calibration_factor',
                updatedFactor['humidity_calibration_factor']
            );
        }
        this.reloadModalViewAll();
    }

    visibilityModalManualFactor(value) {
        this.visibleModalManualFactor = value;
    }

    closeModalManualFactor() {
        this.patchData = null;
        this.manualFactorToDelete = null;
        this.visibilityModalManualFactor(false);
    }

    clickAddNewFactor() {
        this.patchData = null;
        this.manualFactorToDelete = null;
        this.visibilityModalManualFactor(true);
    }

    editManualFactor(item) {
        this.patchData = item;
        this.visibilityModalManualFactor(true);
    }

    deleteManualFactor(item) {
        this.manualFactorToDelete = item;

        this.showDeleteConfirmationDialog(
            'Eliminar factor manual',
            '¿Está seguro que desea eliminar este factor manual'
        );
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            if (!this.saveOnMemory) {
                this.deleteFactor();
            } else {
                this.removeFactorFromList();
            }
        } else {
            this.confirmationDelete = false;
        }
    }

    deleteFactor() {
        let self = this;
        if (this.manualFactorToDelete !== null) {
            this.loadingIgnoredPeriods = true;
            this.pendingTable(true);
            InsuranceServices.deleteCustomCalibrationFactor(this.manualFactorToDelete['id'])
                .then(response => {
                    let msg = '';
                    if (response && response.data && response.data.message) {
                        msg = response.data.message;
                    } else {
                        msg = 'Factor Eliminado con éxito';
                    }
                    this.loadingIgnoredPeriods = false;

                    this.$_successDeleteRecipients(msg);
                    this.removeFactorFromList();
                    this.pendingTable(false);
                    this.reloadModalViewAll();
                })
                .catch(error => {
                    this.loadingIgnoredPeriods = false;
                    this.pendingTable(false);
                    this.showMsgError(error);
                });
        }
    }

    @Emit()
    reloadModalViewAll() {}

    removeFactorFromList() {
        this.itemsManualFactors = removeItemsFromList(this.itemsManualFactors, [this.manualFactorToDelete], 'id');
    }

    showMsgError(error) {
        let self = this;
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'Ocurrió un error';
        }
        this.$_errorAddFilter(msg);
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    formatBoolean(value) {
        return booleanFormatter(value);
    }
}
